//* Libraries imports
import { Suspense } from "react";

//* Components imports
import { Content } from "./_components";
import { WithPermissionCheck } from "../../../components/common/WithPermissionCheck";

export default function ProcessExamList() {
  return (
    <WithPermissionCheck>
      <div className="row">
        <Suspense>
          <Content />
        </Suspense>
      </div>
    </WithPermissionCheck>
  );
}
